import { motion } from "framer-motion";

const EASE = [0.19, 1, 0.22, 1];

export const RevealLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.09, inView = true, testid }) => {
  const parent = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const child = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE } } };
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.div data-testid={testid} className={className} variants={parent} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] pt-[0.16em] -mt-[0.16em]">
          <motion.span className={`block ${lineClassName}`} variants={child}>{l}</motion.span>
        </span>
      ))}
    </motion.div>
  );
};

export const FadeUp = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
